import { post } from "../utils/backend";
import { ChatMessageDTO, ChatQueryParams } from "../models/Chat";
import { mock } from "./mock/Mock";
import { getMockData } from "./mock/Mock";
import "./mock/ChatMock";

const getRoomMessagesByUser = async (params: ChatQueryParams): Promise<ChatMessageDTO[]> => {
    if (mock) {
        return getMockData("room_messages");
    }
    const resultOrErrorCode = await post<ChatQueryParams, ChatMessageDTO[]>("/managerment/chat/getRoomMessagesByUser", params);
    if (typeof resultOrErrorCode === 'string') {
        // 错误码处理
        return [];
    }
    return resultOrErrorCode;
};

const getMessagesBySeller = async (params: ChatQueryParams): Promise<ChatMessageDTO[]> => {
    if (mock) {
        return getMockData("seller_messages");
    }
    const resultOrErrorCode = await post<ChatQueryParams, ChatMessageDTO[]>("/managerment/chat/getMessagesBySeller", params);
    if (typeof resultOrErrorCode === 'string') {
        // 错误码处理
        return [];
    }
    return resultOrErrorCode;
};

const getMessagesByBuyer = async (params: ChatQueryParams): Promise<ChatMessageDTO[]> => {
    if (mock) {
        return getMockData("buyer_messages");
    }
    const resultOrErrorCode = await post<ChatQueryParams, ChatMessageDTO[]>("/managerment/chat/getMessagesByBuyer", params);
    if (typeof resultOrErrorCode === 'string') {
        // 错误码处理
        return [];
    }
    return resultOrErrorCode;
};

export const ChatApi = {
    getRoomMessagesByUser,
    getMessagesBySeller,
    getMessagesByBuyer
};